import { api } from "../api";
import axios from "axios";


export const getStatus= async () => {
    const res = await axios.get(api+'status/' , {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json", 
}});
    return res.data;
}
export const getStatusE= async () => {
    const res = await axios.get(api+'statusE/' , {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json", 
}});
    return res.data;
}

export const getStatusById= async (id) => {
    const res = await axios.get(api+'status/'+id , {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json", 
}});
    return res.data;
}

export const getStatusByIdE= async (id) => {
    const res = await axios.get(api+'statusE/'+id , {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json", 
}});
    return res.data;
}

export const getStatusByName= async (name) => {
    const res = await axios.get(api+'status/name/'+name , {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json", 
}});
    return res.data;
}
export const getStatusByNameE= async (name) => {
    const res = await axios.get(api+'statusE/name/'+name , {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json", 
}});
    return res.data;
}




export const addStatus= async(titre) => {
    await axios.post(api+'status',{
        titre: titre
    } , {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",
}});
}

export const updateStatus = async (statusId, titre) => {
    await axios.put(api + 'status/' + statusId, {
        titre: titre
    }, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            Accept: "application/json",
        }
    });
}



export const deleteStatus = async (statusId) => {
    await axios.delete(api+'status/'+statusId , {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json", 
}});
}
